export var Completed;
(function (Completed) {
    Completed[Completed["No"] = 0] = "No";
    Completed[Completed["Yes"] = 1] = "Yes";
})(Completed || (Completed = {}));
export var DialogMode;
(function (DialogMode) {
    DialogMode[DialogMode["Add"] = 0] = "Add";
    DialogMode[DialogMode["Delete"] = 1] = "Delete";
    DialogMode[DialogMode["Update"] = 2] = "Update";
    DialogMode[DialogMode["MultiskillWarning"] = 3] = "MultiskillWarning";
})(DialogMode || (DialogMode = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["EN_US"] = "en-US";
    LanguageCode["FR"] = "fr";
})(LanguageCode || (LanguageCode = {}));
export var QueueStatusType;
(function (QueueStatusType) {
    QueueStatusType["Volume"] = "volume";
    QueueStatusType["HandleTime"] = "handleTime";
    QueueStatusType["LearnCurve"] = "learnCurve";
    QueueStatusType["Attrition"] = "attrition";
    QueueStatusType["Shrinkages"] = "shrinkages";
    QueueStatusType["WorkingDays"] = "workingDays";
    QueueStatusType["SupportStaff"] = "supportStaff";
    QueueStatusType["Salary"] = "salary";
    QueueStatusType["WAP"] = "wap";
    QueueStatusType["WAT"] = "wat";
    QueueStatusType["WAV"] = "wav";
    QueueStatusType["FTEDay"] = "fteDay";
    QueueStatusType["Rate"] = "rate";
    QueueStatusType["ProdHours"] = "prodHours";
})(QueueStatusType || (QueueStatusType = {}));
export var WorkType;
(function (WorkType) {
    WorkType[WorkType["InboundCalls"] = 1] = "InboundCalls";
    WorkType[WorkType["OutboundCalls"] = 2] = "OutboundCalls";
    WorkType[WorkType["Email"] = 3] = "Email";
    WorkType[WorkType["Chat"] = 4] = "Chat";
    WorkType[WorkType["SMS"] = 5] = "SMS";
    WorkType[WorkType["Social"] = 6] = "Social";
    WorkType[WorkType["LetterMail"] = 7] = "LetterMail";
    WorkType[WorkType["Fax"] = 8] = "Fax";
    WorkType[WorkType["WorkItems"] = 9] = "WorkItems";
    WorkType[WorkType["Other"] = 10] = "Other";
})(WorkType || (WorkType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["InHouse"] = "in_house";
    LocationType["Outsourced"] = "outsourced";
})(LocationType || (LocationType = {}));
